module.exports = __webpack_public_path__ + "img/case28-jpg.4c0abe56.jpg";